import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface InvsmtInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function InvsmtInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: InvsmtInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Investments"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

